import { Box } from '@withjoy/joykit';
import type { ProductAttributeSelectorProps } from '../config.types';
import type { Option } from '../product.types';
import { GenericChoiceGroupAttribute } from './GenericChoiceGroupAttribute';
import React from 'react';
import { animationTransition } from '@shared/utils/animationTransition';

/**
 * Defines border radius props for given OptionID
 */
const optionIdToBorderRadii = (optionId: string) => {
  switch (optionId) {
    case 'rectangle': {
      return {};
    }
    case 'rounded': {
      return {
        borderRadius: 8,
      };
    }
    case 'arch': {
      return {
        borderTopLeftRadius: 32,
        borderTopRightRadius: 32,
      };
    }
    default:
      return null;
  }
};

const SelectionOption = (props: { optionId: string; isPossible: boolean }) => {
  const borderRadii = optionIdToBorderRadii(props.optionId);

  if (!borderRadii) {
    return null;
  }

  return (
    <Box
      borderColor="mono14"
      borderStyle="solid"
      borderWidth="1px"
      width={32}
      aspectRatio="5/7"
      {...borderRadii}
      opacity={props.isPossible ? 1 : 0.2}
      transition={animationTransition('opacity')}
    />
  );
};

export const DieCutIconAttribute = (props: ProductAttributeSelectorProps) => {
  const getOptionComponent = (option: Option, isPossible: boolean, index: number) => {
    return (
      <SelectionOption
        key={index}
        optionId={option.optionId}
        isPossible={isPossible}
      />
    );
  };

  const getChoiceGroupName = (option: Option) => {
    return option.title;
  };

  return (
    <GenericChoiceGroupAttribute
      {...props}
      minHeight={98}
      getOptionComponent={getOptionComponent}
      getChoiceGroupName={getChoiceGroupName}
    />
  );
};
